import { inject, PLATFORM_ID } from '@angular/core';
import {
  CanActivateFn,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { ProjectService } from '../services/project.service';

export const navigateGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const projectService = inject(ProjectService);
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);

  // Permitir acceso si el servicio indica navegación válida
  if (projectService.getNavigationState()) {
    return true;
  }

  // Permitir acceso si hay progreso guardado en localStorage
  if (isPlatformBrowser(platformId) && localStorage.getItem('gameState')) {
    return true;
  }

  // Si no hay progreso, redirigir a view-form si tenemos los parámetros, sino a home
  const idform = route.paramMap.get('idform');
  const slug = route.paramMap.get('slug');

  if (idform && slug) {
    router.navigate(['/games/view-form', idform, slug]);
  } else {
    router.navigate(['/']);
  }
  return false;
};
